export default __webpack_public_path__ + "static/media/CashbackBlack.05f891bc.svg";